import { useBorrowerFirstLoanWithBfi } from '../../../../../../../queries/BorrowerFields/CoreFields';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../../../../../components/ApplicationQuestionReviewItem';

interface ConfirmFirstLoanProps {
    required?: boolean;
    isReview?: boolean;
}

export const ConfirmFirstLoan: React.FC<ConfirmFirstLoanProps> = ({ required = false, isReview = false }) => {
    const label = 'Is this your first loan application with BFI?';
    const [firstLoanWithBfi, set_firstLoanWithBfi] = useBorrowerFirstLoanWithBfi();

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_firstLoanWithBfi(true);
                return;
            case 'no':
                set_firstLoanWithBfi(false);
                return;
            default:
                return;
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={firstLoanWithBfi ? 'Yes' : 'No'}
                />
            ) : (
                <YesNoToggleButton
                    id='firstLoadApplicationWithBfi'
                    value={firstLoanWithBfi}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={required}
                    requiredMessage='This is required'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Large}
                />
            )}
        </>
    );
};
